module.exports = import("https://mozilla.github.io/pdf.js/build/pdf.mjs");;